 const products = [
    {
      id: '001',
      title: 'Product 1',
      image: '../images/shirt-1.webp',
      image2: '../images/shirt-2.webp',
      price: 19.99,
      actualprice: 24.99,
      category: 'Electronics',
      size: 'Medium',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      inStock: true,
      quantity: 10,
      rating: 3.5,
    },
    {
      id: '002',
      title: 'Product 2',
      image: '../images/shirt-1.webp',
      image2: '../images/shirt-2.webp',
      price: 9.99,
      actualprice: 14.99,
      category: 'Clothing',
      size: 'Large',
      description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
      inStock: true,
      quantity: 5,
      rating: 3.5,
    },
    {
      id: '003',
      title: 'Product 3',
      image: '../images/shirt-1.webp',
      image2: '../images/shirt-2.webp',
      price: 49.99,
      actualprice: 59.99,
      category: 'Home & Kitchen',
      size: 'One Size',
      description: 'At vero eos et accusamus et iusto odio dignissimos ducimus.',
      inStock: false,
      quantity: 0,
      rating: 3.5,
    },
    {
      id: '004',
      title: 'Product 4',
      image: '../images/shirt-1.webp',
      image2: '../images/shirt-2.webp',
      price: 29.99,
      actualprice: 34.99,
      category: 'Beauty',
      size: 'Small',
      description: 'Quis autem vel eum iure reprehenderit qui in ea voluptate velit.',
      inStock: true,
      quantity: 7,
      rating: 3.5,
    },
    {
      id: '005',
      title: 'Product 5',
      image: '../images/shirt-1.webp',
      image2: '../images/shirt-2.webp',
      price: 14.99,
      actualprice: 19.99,
      category: 'Sports',
      size: 'Large',
      description: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.',
      inStock: true,
      quantity: 3,
      rating: 3.5,
    },
    {
      id: '006',
      title: 'Product 6',
      image: '../images/shirt-1.webp',
      image2: '../images/shirt-2.webp',
      price: 39.99,
      actualprice: 44.99,
      category: 'Toys',
      size: 'One Size',
      description: 'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis.',
      inStock: true,
      quantity: 9,
      rating: 3.5,
    },
    {
      id: '007',
      title: 'Product 7',
      image: '../images/shirt-1.webp',
      image2: '../images/shirt-2.webp',
      price: 24.99,
      actualprice: 29.99,
      category: 'Books',
      size: 'Medium',
      description: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.',
      inStock: false,
      quantity: 0,
      rating: 3.5,
    },
    {
      id: '008',
      title: 'Product 8',
      image: '../images/shirt-1.webp',
      image2: '../images/shirt-2.webp',
      price: 79.99,
      actualprice: 89.99,
      category: 'Electronics',
      size: 'Large',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      inStock: true,
      quantity: 12,
      rating: 3.5,
    },
  ];
  
  export default products;
  